<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="x04A-Para-1-2">The cradle rocks above an abyss, and common sense tells us that our existence is but a brief crack of light between two eternities of darkness.</p>
<p class="Normal"><span class="ePub-SC">VLADIMIR NABOKOV</span>, <span class="ePub-I">Speak, Memory</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?029b9f28